import { authedJSON } from './http'
import type {
  OrderIntent,
  PreflightResponse,
  FleetSubmitResult,
  FleetPortfolio,
  FleetTradeRow,
} from './types'

export interface SizingSpec {
  mode: 'SHARES' | 'PERCENT' | 'DOLLARS'
  value: number
}

export function previewFleet(body: {
  intent: OrderIntent
  sizing: SizingSpec
  referencePrice: number
}): Promise<PreflightResponse> {
  return authedJSON<PreflightResponse>('/api/fleet/preflight', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function submitFleet(body: {
  intent: OrderIntent
  sizing: SizingSpec
  referencePrice: number
}): Promise<FleetSubmitResult> {
  return authedJSON<FleetSubmitResult>('/api/fleet/orders', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getFleetPortfolio(): Promise<FleetPortfolio> {
  return authedJSON<FleetPortfolio>('/api/fleet/portfolio')
}

export function getFleetTrades(limit = 100): Promise<{ trades: FleetTradeRow[] }> {
  return authedJSON<{ trades: FleetTradeRow[] }>(`/api/fleet/trades?limit=${limit}`)
}

export function setAccountArmed(accountId: string, armed: boolean): Promise<{ accountId: string; armed: boolean }> {
  return authedJSON(`/api/accounts/${encodeURIComponent(accountId)}/arm`, {
    method: 'POST',
    body: JSON.stringify({ armed }),
  })
}
